export default "__VITE_ASSET__DI_8vynK__"